import React from 'react'
import { Grid, Space, AutoCenter, NavBar, Button } from 'antd-mobile'
import { UndoOutline } from 'antd-mobile-icons'
import { Link } from 'react-router-dom'
import { getAuth, sendEmailVerification, User } from '@firebase/auth'
import { useTranslation } from 'react-i18next'

const ConfirmRegister: React.FC = () => {
  const { t } = useTranslation()
  const auth = getAuth()

  const handleResend = async () => {
    const url = `${window?.location.origin}/login`

    const actionCodeSettings = {
      url: url,
      handleCodeInApp: true,
    }

    sendEmailVerification(auth.currentUser as User, actionCodeSettings)
  }

  return (
    <div className="container" style={{ backgroundColor: 'var(--main-background-color)', padding: '10px 20px 60px' }}>
      <Link to="/register">
        <NavBar style={{ color: '#ffffff' }} />
      </Link>
      <Grid
        columns={1}
        gap="24px"
        style={{
          borderRadius: 'var(--wrapper-border-radius)',
          backgroundColor: '#ffffff',
          paddingTop: '32px',
          paddingRight: '15px',
          paddingBottom: '32px',
          paddingLeft: '15px',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Grid.Item>
          <AutoCenter style={{ fontSize: '18px', fontWeight: 400, color: '#000000' }}>
            {t('confirm-register.header')}
          </AutoCenter>
        </Grid.Item>
        <Grid.Item>
          <Space block justify="center">
            <div
              style={{
                width: '133px',
                height: '157px',
                backgroundImage: `url('/images/sugnee.svg')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                borderRadius: 'var(--avatar-border-radius)',
              }}
            />
          </Space>
        </Grid.Item>
        <Grid.Item style={{ color: '#000000', fontSize: '16px', fontWeight: '400' }}>
          <Space>{t('confirm-register.message1')}</Space>
          <Space wrap style={{ display: 'block' }}>
            {t('confirm-register.message2')}
          </Space>
        </Grid.Item>
        <Grid.Item>
          <AutoCenter>
            <Button color="primary" loading="auto" fill="none" style={{ fontSize: '12px' }} onClick={handleResend}>
              <UndoOutline style={{ marginRight: '5px' }} />
              {t('confirm-register.button.resend')}
            </Button>
          </AutoCenter>
        </Grid.Item>
      </Grid>
    </div>
  )
}

export default ConfirmRegister
